import { render, staticRenderFns } from "./ClientCustomizer.vue?vue&type=template&id=6916097f&scoped=true&"
import script from "./ClientCustomizer.vue?vue&type=script&lang=js&"
export * from "./ClientCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ClientCustomizer.vue?vue&type=style&index=0&id=6916097f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916097f",
  null
  
)

export default component.exports